"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaggingsContentTypes = void 0;
var TaggingsContentTypes;
(function (TaggingsContentTypes) {
    TaggingsContentTypes["LESSON"] = "lesson";
    TaggingsContentTypes["COURSE"] = "course";
    TaggingsContentTypes["VIDEO_TUTORIAL"] = "videoTutorial";
    TaggingsContentTypes["CHALLENGE"] = "challenge";
    TaggingsContentTypes["LEARNING_PATH"] = "learningPath";
    TaggingsContentTypes["SKILL_TREE"] = "skillTree";
    TaggingsContentTypes["LAB"] = "lab";
})(TaggingsContentTypes = exports.TaggingsContentTypes || (exports.TaggingsContentTypes = {}));
